import React from 'react';
import maintenanceImage from '../../asset/wh.png';
import s from './index.module.css';

const MaintenanceContent = ({ moduleName }) => {
    return (
        <div className={s.maintenanceContent}>
            <img
                src={maintenanceImage}
                alt="维护中"
                className={s.maintenanceImg}
            />
            <h3 className={s.maintenanceTitle}>温馨提示</h3>
            <p className={s.maintenanceDesc}>{moduleName || '该服务模块'}正在维护中，暂时无法访问，请稍后再试。</p>
        </div>
    );
};

export default MaintenanceContent;